"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "combineModels", {
  enumerable: true,
  get: function get() {
    return _redux.combineModels;
  }
});

_Object$defineProperty(exports, "createEntityMock", {
  enumerable: true,
  get: function get() {
    return _mocks.createEntityMock;
  }
});

_Object$defineProperty(exports, "createMockEntity", {
  enumerable: true,
  get: function get() {
    return _entity.createMockEntity;
  }
});

_Object$defineProperty(exports, "createMockStore", {
  enumerable: true,
  get: function get() {
    return _store.createMockStore;
  }
});

_Object$defineProperty(exports, "createMockStoreWrapper", {
  enumerable: true,
  get: function get() {
    return _wrapper.createMockStoreWrapper;
  }
});

exports.default = void 0;

_Object$defineProperty(exports, "fixCasing", {
  enumerable: true,
  get: function get() {
    return _mappings.fixCasing;
  }
});

_Object$defineProperty(exports, "fragment", {
  enumerable: true,
  get: function get() {
    return _queries.fragment;
  }
});

_Object$defineProperty(exports, "generateActionCreators", {
  enumerable: true,
  get: function get() {
    return _connectors.generateActionCreators;
  }
});

_Object$defineProperty(exports, "mapDispatch", {
  enumerable: true,
  get: function get() {
    return _connectors.mapDispatch;
  }
});

_Object$defineProperty(exports, "mapEntityDispatch", {
  enumerable: true,
  get: function get() {
    return _connectors.mapEntityDispatch;
  }
});

_Object$defineProperty(exports, "mapEntityListState", {
  enumerable: true,
  get: function get() {
    return _connectors.mapEntityListState;
  }
});

_Object$defineProperty(exports, "mapEntityState", {
  enumerable: true,
  get: function get() {
    return _connectors.mapEntityState;
  }
});

_Object$defineProperty(exports, "mapState", {
  enumerable: true,
  get: function get() {
    return _connectors.mapState;
  }
});

_Object$defineProperty(exports, "mapValueListDispatch", {
  enumerable: true,
  get: function get() {
    return _connectors.mapValueListDispatch;
  }
});

_Object$defineProperty(exports, "mapValueListState", {
  enumerable: true,
  get: function get() {
    return _connectors.mapValueListState;
  }
});

_Object$defineProperty(exports, "mergeProps", {
  enumerable: true,
  get: function get() {
    return _connectors.mergeProps;
  }
});

_Object$defineProperty(exports, "query", {
  enumerable: true,
  get: function get() {
    return _queries.query;
  }
});

_Object$defineProperty(exports, "touchEtag", {
  enumerable: true,
  get: function get() {
    return _entities.touchEtag;
  }
});

_Object$defineProperty(exports, "useEntity", {
  enumerable: true,
  get: function get() {
    return _useEntity.default;
  }
});

_Object$defineProperty(exports, "useEntityList", {
  enumerable: true,
  get: function get() {
    return _useEntityList.default;
  }
});

_Object$defineProperty(exports, "useEntityListQuery", {
  enumerable: true,
  get: function get() {
    return _useEntityListQuery.default;
  }
});

_Object$defineProperty(exports, "useEntityQuery", {
  enumerable: true,
  get: function get() {
    return _useEntityQuery.default;
  }
});

_Object$defineProperty(exports, "useModelActions", {
  enumerable: true,
  get: function get() {
    return _useModelActions.default;
  }
});

_Object$defineProperty(exports, "useModelState", {
  enumerable: true,
  get: function get() {
    return _useModelState.default;
  }
});

_Object$defineProperty(exports, "withEntity", {
  enumerable: true,
  get: function get() {
    return _connectors.withEntity;
  }
});

_Object$defineProperty(exports, "withEntityList", {
  enumerable: true,
  get: function get() {
    return _connectors.withEntityList;
  }
});

_Object$defineProperty(exports, "withModel", {
  enumerable: true,
  get: function get() {
    return _connectors.withModel;
  }
});

_Object$defineProperty(exports, "withQuery", {
  enumerable: true,
  get: function get() {
    return _connectors.withQuery;
  }
});

_Object$defineProperty(exports, "withValueLists", {
  enumerable: true,
  get: function get() {
    return _connectors.withValueLists;
  }
});

// Add named import of ReduxModelGenerator
var _modelGenerator = _interopRequireDefault(require("./model-generator"));
_Object$defineProperty(exports, "ReduxModelGenerator", {
  enumerable: true,
  get: function get() {
    return _modelGenerator.default;
  }
});

var _redux = require("./utils/redux");

var _queries = require("./utils/queries");

var _connectors = require("./connectors");

var _mappings = require("./mappings");

var _entities = require("./actions/entities");

var _useModelActions = _interopRequireDefault(require("./hooks/use-model-actions"));

var _useModelState = _interopRequireDefault(require("./hooks/use-model-state"));

var _useEntity = _interopRequireDefault(require("./hooks/use-entity"));

var _useEntityList = _interopRequireDefault(require("./hooks/use-entity-list"));

var _useEntityQuery = _interopRequireDefault(require("./hooks/use-entity-query"));

var _useEntityListQuery = _interopRequireDefault(require("./hooks/use-entity-list-query"));

var _mocks = require("./test-utils/mocks");

var _store = require("./test-utils/store");

var _entity = require("./test-utils/entity");

var _wrapper = require("./test-utils/wrapper");

// testing
var _default = _modelGenerator.default;
exports.default = _default;